<template>
  <div style="width: 100%;height: 100%;" class="body2">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="applyIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" @click="urlTo('home')">首页</a> / <a href="javascript:void(0)"  @click="urlTo('applyIndex')">个人办事</a> / <span>{{title}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>
        <div  class="wraper">
          <div class="publicity">
            <div class="division1" >
              <span>所在区划：
                <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"  clearable placeholder="请选择所在区划" style="width: 160px;"></el-cascader>
              </span>
<!--              <el-button    @click="urlTo('marriageAppointmentSubmit',{opType:opType,deptName:'1111',deptId:'2222',timeId:'4444',bookDate:'5454444',title:title,startTime:'34345345',endTime:'535435435',swFlag:swFlag,allowYd:allowYd,deptCode:'63'})" type="primary">预约</el-button>-->
              <span  v-if="selectedRegion!=''&& selectedRegion!=undefined && selectedRegion!=-1"> 登记处名称：
                <el-select
                  v-model="data.deptId"
                  collapse-tags
                  placeholder="请选择" style="width: 200px;">
                   <el-option
                     v-for="item in registryType"
                     :key="item.id"
                     :label="item.name"
                     :value="item.deptCode" >
                   </el-option>
                 </el-select>
              </span>
            </div>
            <div style="height: 100px">&nbsp;</div>
            <div  v-loading="loading" v-if="dataList.length>0" v-for="(item,index) in dataList">
              <div style="background-color: #409EFF;width: 150px;font-weight: 600;margin-bottom: -40px;height: 28px;font-size: 20px;color: white;text-align: center" v-if="item.timeList && item.timeList.length>0 && item.isHoliday">
                {{item.bookDate}}
              </div>
              <table  width="100%" border="0" cellspacing="1" cellpadding="0" v-if="item.timeList && item.timeList.length>0 && item.isHoliday">
                <tr class="first">
                  <td >预约时段</td>
                  <td width="300px">数量</td>
                  <td width="70">操作</td>
                </tr>
                <tr  v-for="(items,index) in item.timeList" :key="index">
                  <td align="left" style="width: 384px;text-align: center" nowrap="true">&nbsp;{{items.startTime}}-{{items.endTime}}</td>
                  <td align="center" nowrap="true">共{{items.allNum}}个 剩余{{items.allNum-items.alreadyNum}}个</td>
                  <td align="center" nowrap="true">
                    <el-button v-if="items.allNum != items.alreadyNum"   @click="urlTo('marriageAppointmentSubmit',{opType:opType,deptName:data.deptName,deptId:data.deptId,timeId:items.id,bookDate:item.bookDate,title:title,startTime:items.startTime,endTime:items.endTime,swFlag:swFlag,allowYd:allowYd,deptCode:data.regionCode})" type="primary">预约</el-button>
                    <el-button  v-else disabled  type="primary">预约</el-button>
                  </td>
                </tr>
              </table >
            </div>
            <div v-else>
              <div style="text-align: center;font-size: 14px; color: rgb(155 159 162);">
                <div><img src="../../../static/images/empty-image-default.png" style="width: 300px;" /></div>
                <div>暂无数据</div>
              </div>
            </div>

            <!--测试使用-->
<!--            <div>
              <el-button @click="urlTo('marriageAppointmentSubmit',{opType:opType,deptName:data.deptName,deptId:data.deptId,timeId:'2022',bookDate:'2023-02-22',title:title,startTime:'9.00',endTime:'12.00',swFlag:swFlag,allowYd:allowYd,deptCode:data.regionCode})" type="primary">预约</el-button>
            </div>-->
           <!-- <div style="text-align: center;height: 50px;line-height: 50px;" v-if="dataObjList.length>0"> <el-pagination
              layout="prev, pager, next"
              :total="pageTotal" :page-size="pageSize" @current-change="pageChange" @prev-click="prevClick" @next-click="nextClieck">
            </el-pagination>
            </div>-->
          </div>
        </div>
      </div>
    </div>

    <div class="clear"></div>
    <footers></footers>
  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";
  let id = 0;

  export default {
    name: "public-index",
    components:{
      headers,fixedDiv,footers
    },
    data() {
      let _self=this;
      return {
        dataObjList:[],
        dataList:[],
        itemMonth:'',
        opType:'',
        swFlag:'0', // 0国内，1涉外
        allowYd: 0, // 校验异地标识,0-区内,1-市内,2-省内,3-省外
        loading:false,
        showClause:false,
        title:'',
        active: 'publicIndex',
        width:document.body.clientWidth+'px',
        height:document.body.clientHeight+'px',
        type:'',
        tabSelect:'apply',
        workDepartId:"",
        pageTotal:1,
        registryType:[],
        timeList:[],
        pname:"",
        props: {
          lazy: true,
          checkstrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value='630000';
              t=1;
              //上级为空，默认设置大通县数据
            }
        /*    else if (node.value.length>8){
              return
            }*/
            const options={areaCode:node.value}
            _self.$https.post("api/marriage/getAreaInfo.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              if (response.status === 200 && response.data.code === 200) {
                const nodes = Object.values(response.data.data).map(function (e) {
                  return {label: e.areaName, value: e.areaCode, level: 0, leaf: level >= 1}
                })
                resolve(nodes);
              } else {
                resolve(nodes);
              }
              // }else{
              //   const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        selectedRegion:[],
        data:{
          deptId:'',
          deptId_text:'',
          deptName:'',
          opType:'',
          bookDate:'',
          bookTimeId:'',
          startTime:'',
          endTime:'',
          nameMan:'',
          idTypeMan:'',
          idTypeWoman:'',
          nationMan:'',
          nationWoman:'',
          certTypeMan:'',
          certTypeWoman:'',
          certNumMan:'',
          certNumWoman:'',
          birthMan:'',
          birthWoman:'',
          folkMan:'',
          folkWoman:'',
          marryStatusMan:'',
          marryStatusWoman:'',
          oldOpDate:'',
          oldDeptName:'',
          oldCertNo:'',
          divorceReason:'',
          jobMan:'',
          jobWoman:'',
          degreeMan:'',
          degreeWoman:'',
          regSjMan:'',
          regSjWoman:'',
          regDsMan:'',
          regDsWoman:'',
          regQxMan:'',
          regQxWoman:'',
          regJxMan:'',
          regJxWoman:'',
          regDetailMan:'',
          regDetailWoman:'',
          mobile:'',
          tel:'',
          swFlag:1,
          edocList:'',
          codeId:'',
          validCode:'',
          ptslh:'',
        },
        selecteddylbOption:[],
        departOption:[],
        pageNum:1,
        pageSize:10,
      }
    } ,
    watch: {
      width(n,o){
        alert(n+'w')
      },
      height(n,o){
        alert(n+'h')
      },
      'data.deptId'(n,o){
        let deptData={};
        deptData=this.registryType.find((item)=>{
          return item.deptCode===n
        })
        this.data.deptId=deptData.deptCode;
        this.data.deptName=deptData.name;
        this.allowYd = deptData.allowYd;
        this.data.regionCode = deptData.regionCode;
        this.selectTimeAppointment();
      },
      selectedRegion(nv){
        this.selectMechanism();
      },

    },
    created(){
      this.showClause=true;
      this.opType = this.$route.query.opType;
      this.swFlag = this.$route.query.swFlag;
      this.title = this.$route.query.title;

    },
    methods: {
      setValue(){
        alert(123)
      },
      prevClick(a){
        this.pageNum=this.pageNum-1;
        this.initData();
      },
      selectTimeAppointment(){
        /*this.loading=true;*/
        const options={
          deptCode:this.data.deptId,
          opType:this.opType,
        }
        this.dataList=[];
        this.$https.post("api/marriage/getBookDates.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.dataList=response.data.data;
          }else {
            this.dataList=[];
            // this.dataList=[
            //   {
            //     bookDate:'2022-1-4',
            //     timeList:[
            //       {
            //         startTime:'8:00',
            //         endTime:'10:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'8:00-10:00'
            //       },
            //       {
            //         startTime:'10:00',
            //         endTime:'12:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'10:00-12:00'
            //       },
            //       {
            //         startTime:'14:00',
            //         endTime:'16:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'14:00-16:00'
            //       },
            //       {
            //         startTime:'16:00',
            //         endTime:'18:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'16:00-18:00'
            //       },
            //     ],
            //   },   {
            //     bookDate:'2022-1-5',
            //     timeList:[
            //       {
            //         startTime:'8:00',
            //         endTime:'10:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'8:00-10:00'
            //       },
            //       {
            //         startTime:'10:00',
            //         endTime:'12:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'10:00-12:00'
            //       },
            //       {
            //         startTime:'14:00',
            //         endTime:'16:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'14:00-16:00'
            //       },
            //       {
            //         startTime:'16:00',
            //         endTime:'18:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'16:00-18:00'
            //       },
            //     ],
            //   },   {
            //     bookDate:'2022-1-6',
            //     timeList:[
            //       {
            //         startTime:'8:00',
            //         endTime:'10:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'8:00-10:00'
            //       },
            //       {
            //         startTime:'10:00',
            //         endTime:'12:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'10:00-12:00'
            //       },
            //       {
            //         startTime:'14:00',
            //         endTime:'16:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'14:00-16:00'
            //       },
            //       {
            //         startTime:'16:00',
            //         endTime:'18:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'16:00-18:00'
            //       },
            //     ],
            //   },   {
            //     bookDate:'2022-1-7',
            //     timeList:[
            //       {
            //         startTime:'8:00',
            //         endTime:'10:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'8:00-10:00'
            //       },
            //       {
            //         startTime:'10:00',
            //         endTime:'12:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'10:00-12:00'
            //       },
            //       {
            //         startTime:'14:00',
            //         endTime:'16:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'14:00-16:00'
            //       },
            //       {
            //         startTime:'16:00',
            //         endTime:'18:00',
            //         allNum:100,
            //         remainingNum:5,
            //         id:'16:00-18:00'
            //       },
            //     ],
            //   },
            //
            // ];
          }
          this.loading=false;
        })
      },
      nextClieck(a){
        this.pageNum=this.pageNum+1;
        this.initData();
      },
      pageChange(a){
        this.pageNum=a
        this.initData();
      },

      search(){
        this.pageNum=1;
        this.dataObjList=[];
        this.initData();
      },
      initData(tts){
        var _wdid=this.workDepartId;
        if(this.selectedRegion && this.selectedRegion.length>0){
          _wdid=this.selectedRegion[this.selectedRegion.length-1];
        }
        // if(_wdid==''){
        //   _wdid=this.old_party_id;
        // }
        const options={
          pname:this.pname,
          workDepartId:_wdid,
          pubTypeId:this.pubTypeId,
          itemMonth:this.itemMonth,
          payMonth:this.payMonth,
          pageNum:this.pageNum,
          pageSize:this.pageSize,
          length: this.selectedRegion.length,
        };
        var t=this;
        this.$https.post("api/pubItem/getPubItem.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            t.dataObjList=[];
            if(null != response.data.data && response.data.data.length>0){
              t.dataObjList=t.dataObjList.concat(response.data.data);
              // t.dataObjList.push(response.data.data);
              t.pageTotal=t.dataObjList[0].total;
            }
          } else {
            t.dataObjList=[];
          }
        })
      },
      selectMechanism(){
        const options={
          regionCode:this.selectedRegion[this.selectedRegion.length-1],
          type:this.swFlag,
        }
        this.$https.post("api/marriage/getMarriageDept.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.registryType=response.data.data;
          }
        })
      },
      urlTo(url,params){
        this.$router.push({path:url,query:params||{}});
      }
    }
  }



</script>
<style>
  .publicity table td {
    padding: 0px 5px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/marriage/MarriageAppointment.vue